import "./EducationCard.scss";

const EducationCard = ({ university, field, period, content }) => {
  const stringParts = content.split("\n");

  // Join the parts with <br /> elements
  const stringWithBreaks = stringParts.join("<br />");
  return (
    <div className="eduCard">
      <h4> {university}</h4>
      <p> {field} </p>
      <h5> {period} </h5>
      <p
        className="eduCard__text"
        dangerouslySetInnerHTML={{ __html: stringWithBreaks }}
      >
      </p>
    </div>
  );
};

export default EducationCard;
